export interface Agent {
  uuid?: string;
  name: string;
  behaviour: string;
  status?: AgentStatus;
  ragDataFile?: File;
  workflowUuid?: string | undefined;
}

export interface Integration {
  uuid?: string;
  name: string;
  type: ChannelType;
  botToken: string;
  agentUuid?: string | undefined;
  secretToken?: string | undefined;
  responseWebhook?: string | undefined;
  status?: IntegrationStatus;
}

export interface ConversationMetadata {
  failedAttempts: number;
  sentiment?: string;
}

export interface Conversations {
  uuid?: string;
  topic: string;
  summary?: string;
  chatMessages?: ChatMessage[];
  type: ChannelType;
  metadata: ConversationMetadata;
}

export interface Workflow {
  uuid?: string;
  name: string;
  status: WorkflowStatus;
  definition: unknown;
}

export interface ChatMessage {
  uuid: string;
  senderId: string;
  senderType: SenderType;
  type: MessageType;
  body: String;
  createdAt: string;
  metadata?: string;
}

export enum AgentStatus {
  START = 'START',
  AWAITING_FILE_UPLOAD = 'AWAITING_FILE_UPLOAD',
  AWAITING_BEHAVIOUR = 'AWAITING_BEHAVIOUR',
  READY = 'READY',
}

export enum WorkflowStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum IntegrationStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum SenderType {
  AI = 'AI',
  HUMAN = 'HUMAN',
  AGENT = 'AGENT',
}

export enum MessageType {
  TEXT = 'TEXT',
}

export enum ChannelType {
  TELEGRAM = 'TELEGRAM',
  WHATSAPP = 'WHATSAPP',
  WEBHOOK = 'WEBHOOK',
}

export enum WebSocketMessageType {
  MESSAGE = 'MESSAGE',
  CONVERSATION = 'CONVERSATION',
}
